var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { attrs: { id: "page" } },
    [
      _c("h1", {
        staticClass: "text-center",
        attrs: { title: "Page Not Found" },
      }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c("b-col", { staticClass: "text-center" }, [
                _c("h2", { staticClass: "not-found-content-header" }, [
                  _vm._v("Oops!"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "not-found-content-text" }, [
                  _vm._v("Something went wrong."),
                  _c("br"),
                  _vm._v("The page you were looking for does not exist!"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "shape-area reversed cyan-inner purple-outer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }